import * as firebase from "firebase";

require("firebase/firestore");

const firebaseConfig = {
  apiKey: "AIzaSyDpy1LQ0Dj-g09kW42C5ypPFCCGpbIr3_U",
  authDomain: "micatalogovirtual-7bfd1.firebaseapp.com",
  projectId: "micatalogovirtual-7bfd1",
  storageBucket: "micatalogovirtual-7bfd1.appspot.com",
  messagingSenderId: "232830642721",
  appId: "1:232830642721:web:69e6788956c4a59f3fd160",
};

const initializedFirebaseApp = firebase.initializeApp(firebaseConfig);

export const messaging = {
  requestPermission: () => {
    return new Promise((resolve, reject) => {
      // Verifica que el navegador soporte Firebase Messaging
      if (!firebase.messaging.isSupported()) {
        reject("Firebase Messaging no es soportado en este navegador.");
        return;
      }

      // Si el permiso ya está concedido, lo resolvemos inmediatamente
      if (Notification.permission === "granted") {
        resolve("Permiso ya concedido.");
      } else if (Notification.permission === "denied") {
        reject("El permiso de notificaciones ha sido denegado.");
      } else {
        // Si el permiso está en estado 'default', solicitamos el permiso
        Notification.requestPermission()
          .then((permission) => {
            if (permission === "granted") {
              resolve("Permiso concedido.");
            } else {
              reject("Permiso no concedido.");
            }
          })
          .catch((err) => reject(err));
      }
    });
  },
  getToken: () => {
    return new Promise((resolve, reject) => {
      // Verifica que el navegador soporte Firebase Messaging
      if (!firebase.messaging.isSupported()) {
        reject("Firebase Messaging no es soportado en este navegador.");
        return;
      }

      const messaging = initializedFirebaseApp.messaging();
      // Obtén el token usando tu vapidKey
      messaging
        .getToken({
          vapidKey:
            "BAmpNqPxBzcPURWTdr6UJocSi5AR4EDlnEF3wGog0e52CS4YtiodANFaNFRvc6onb-Z9LwR32TLoITLSZ8vGf44",
        })
        .then((token) => {
          if (token) {
            resolve(token);
          } else {
            reject("No se recibió token.");
          }
        })
        .catch((err) => reject(err));
    });
  },
};

export const db = firebase.firestore();

export const getTiendaInfo = (idtienda) => {
  // console.log(idtienda)
  // console.log(idtienda); return true;
  var tiendaRef = firebase
    .firestore()
    .collection("stores")
    .where("tienda", "==", idtienda)
    .where("active", "==", true);
  return tiendaRef
    .get()
    .then((snap) => {
      if (!snap.empty) {
        const tiendaPrev = snap.docs[0];
        var finalRef = firebase
          .firestore()
          .collection("clients")
          .doc(tiendaPrev.id);
        return finalRef.get().then((info) => {
          if (info.exists) {
            return {
              ...info.data(),
              id: tiendaPrev.id,
            };
          }
        });
      } else {
        throw new Error("No ha cargado el documento");
      }
    })
    .catch((err) => {
      throw new Error("No ha cargado el documento");
      // throw new Error('Error inesperado');
      // return error;
    });
};

/**
 *
 * @param {*} param0
 */
export const queryObjectCollection = ({ collection, currentStore }) => {
  if (currentStore && currentStore.hasOwnProperty("id")) {
    let currentUserId = currentStore.id;
    let collectionRef = firebase
      .firestore()
      .collection("clients")
      .doc(currentUserId)
      .collection(collection);

    let results = [];

    return collectionRef
      .orderBy("created", "desc")
      .where("status", "==", 1)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          results.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        return results;
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
        return error;
      });
  }
};

export const queryObjectCollectionByPosition = ({
  collection,
  currentStore,
}) => {
  if (currentStore && currentStore.hasOwnProperty("id")) {
    let currentUserId = currentStore.id;
    let collectionRef = firebase
      .firestore()
      .collection("clients")
      .doc(currentUserId)
      .collection(collection);

    let results = [];

    return (
      collectionRef
        .orderBy("position", "asc")
        //.where('owner', '==', currentUserId)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            results.push({
              id: doc.id,
              ...doc.data(),
            });
          });
          return results;
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
          return error;
        })
    );
  }
};

export const queryObjectCollectionSearch = ({
  collection,
  currentStore,
  id,
}) => {
  if (currentStore && currentStore.hasOwnProperty("id")) {
    let currentUserId = currentStore.id;
    let collectionRef = firebase
      .firestore()
      .collection("clients")
      .doc(currentUserId)
      .collection(collection)
      .doc(id);
    return (
      collectionRef
        //.where('owner', '==', currentUserId)
        .get()
        .then((querySnapshot) => {
          return {
            ...querySnapshot.data(),
          };
          // console.log(querySnapshot, querySnapshot.data());
          // querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          // return {
          // id: doc.id,
          // ...doc.data(),
          // };
          // });
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
          return error;
        })
    );
  }
};

export const queryObjectCollection2 = ({ collection, currentStore }) => {
  let currentUserId = currentStore.id;
  let collectionRef = firebase
    .firestore()
    .collection("clients")
    .doc(currentUserId)
    .collection(collection);

  let results = [];

  return (
    collectionRef
      .orderBy("created", "desc")
      //.where('owner', '==', currentUserId)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          results.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        return results;
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
        return error;
      })
  );
};

/**
 *
 * @param {*} _collection - name of collection to add object to
 * @param {*} _objectData - data to add to the collection
 */
export const addObjectToCollection = ({
  collection,
  objectData,
  currentStore,
}) => {
  let currentUserId = currentStore.id;
  let collectionRef = firebase
    .firestore()
    .collection("clients")
    .doc(currentUserId)
    .collection(collection);

  let tempObj = {
    created: new Date().getTime(),
    updated: new Date().getTime(),
  };

  return collectionRef
    .add({
      ...objectData,
      ...tempObj,
    })
    .then(
      async (doc) => {
        // console.log(`addObjectToCollection ${collection} ${doc}`);

        let docData = await getByRef(doc);
        return docData;
      },
      (error) => {
        console.log(`ERROR: addObjectToCollection ${collection} ${error}`);
        return error;
      }
    )
    .catch((e) => {
      console.log(`ERROR: addObjectToCollection ${collection} ${e}`);
      return e;
    });
};

/**
 *
 * @param {*} _collection - name of collection to update object to
 * @param {*} _objectData - data to set to the collection
 */
export const setObjectToCollection = ({
  collection,
  id,
  objectData,
  currentStore,
}) => {
  let currentUserId = currentStore.id;
  let collectionRef = firebase
    .firestore()
    .collection("clients")
    .doc(currentUserId)
    .collection(collection)
    .doc(id);
  // console.log(id, objectData);
  // let tempObj = {
  // updated: new Date().getTime(),
  // };

  return collectionRef
    .update(objectData)
    .then(
      async () => {
        let docData = await getByRef(collectionRef);
        return docData;
      },
      (error) => {
        console.log(`ERROR: setObjectToCollection ${collection} ${error}`);
        return error;
      }
    )
    .catch((e) => {
      console.log(`ERROR: setObjectToCollection ${collection} ${e}`);
      return e;
    });
};

export const saveNewStore = (store) => {
  let currentUserId = firebase.auth().currentUser.uid;
  let ref = firebase.firestore().collection("stores").doc(currentUserId);

  let tempObj = {
    updated: new Date().getTime(),
    tienda: store,
  };

  return ref
    .set({
      ...tempObj,
    })
    .then(
      async (doc) => {
        let docData = await getByRef(ref);
        return docData;
      },
      (error) => {
        console.log(`ERROR: saveNewStore ${store} ${error}`);
        return error;
      }
    )
    .catch((e) => {
      console.log(`ERROR: saveNewStore ${store} ${e}`);
      return e;
    });
};

/**
 *
 * @param {*} collection - name of collection
 * @param {*} objectId - id of data to remove from the collection
 */
export const removeObjectFromCollection = ({ collection, objectId }) => {
  let currentUserId = firebase.auth().currentUser.uid;
  let collectionRef = firebase
    .firestore()
    .collection("clients")
    .doc(currentUserId)
    .collection(collection);

  return collectionRef
    .doc(objectId)
    .delete()
    .then(
      async (doc) => {
        console.log(`removeObjectFromCollection ${collection} ${objectId}`);
        return true;
      },
      (error) => {
        console.log(`ERROR: removeObjectFromCollection ${collection} ${error}`);
        return error;
      }
    )
    .catch((e) => {
      console.log(`ERROR: removeObjectFromCollection ${collection} ${e}`);
      return e;
    });
};

export const checkIfStoreExists = (_store) => {
  let ref = firebase.firestore().collection("stores");
  let results = [];

  return ref
    .where("tienda", "==", _store)
    .get()
    .then((docs) => {
      docs.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        results.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      // console.log(results);
      return { ...results[0] };
    })
    .catch((error) => {
      return error;
    });
};

export const getByRef = (_documentRef) => {
  return _documentRef
    .get()
    .then((doc) => {
      if (doc.exists) {
        return { ...doc.data(), id: _documentRef.id };
      } else {
        // doc.data() will be undefined in this case
        // console.log("No such document!");
        return null;
      }
    })
    .catch((error) => {
      console.log("Error getting document:", error);
      return error;
    });
};

export const saveInClientProfile = (registros) => {
  let user = firebase.auth().currentUser;

  var userRef = firebase.firestore().collection("clients").doc(user.uid);
  return userRef
    .update(registros)
    .then((response) => {
      // console.log(response);
    })
    .catch((error) => {
      console.log("Error getting document:", error);
    });
};
